/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminAdvanceTeamResponse
 */
export interface AdminAdvanceTeamResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminAdvanceTeamResponse
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAdvanceTeamResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAdvanceTeamResponse
     */
    winnerId: string;
}

/**
 * Check if a given object implements the AdminAdvanceTeamResponse interface.
 */
export function instanceOfAdminAdvanceTeamResponse(value: object): value is AdminAdvanceTeamResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('winnerId' in value) || value['winnerId'] === undefined) return false;
    return true;
}

export function AdminAdvanceTeamResponseFromJSON(json: any): AdminAdvanceTeamResponse {
    return AdminAdvanceTeamResponseFromJSONTyped(json, false);
}

export function AdminAdvanceTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAdvanceTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'status': json['status'],
        'winnerId': json['winnerId'],
    };
}

export function AdminAdvanceTeamResponseToJSON(json: any): AdminAdvanceTeamResponse {
    return AdminAdvanceTeamResponseToJSONTyped(json, false);
}

export function AdminAdvanceTeamResponseToJSONTyped(value?: AdminAdvanceTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'status': value['status'],
        'winnerId': value['winnerId'],
    };
}

